import { render } from "./HollandFAQ.vue?vue&type=template&id=87d193f6&scoped=true"
import script from "./HollandFAQ.vue?vue&type=script&lang=js"
export * from "./HollandFAQ.vue?vue&type=script&lang=js"

import "./HollandFAQ.vue?vue&type=style&index=0&id=87d193f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87d193f6"]])

export default __exports__